/**
 * ALLPOWERS 德国站｜同页产品选型 V4
 *
 * - 所有关联商品/Variant 均在当前页面选择，不跳转。
 * - 所选 Variant ID 同步到加入购物车、动态结账、分期表单和吸底购买栏。
 * - 当前商品内部 Variant 继续调用 Electro 主题原生切换逻辑。
 * - 选中一张卡片时，只展开该卡片的说明与 Lieferumfang。
 */
(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-de-product-options]";
  const INPUT_SELECTOR = "[data-de-option-input]";
  const CARD_SELECTOR = "[data-de-option-card]";
  const NATIVE_INPUT_SELECTOR =
    "[data-de-native-variant-picker] .js-variant-radio-item";

  function parseOptions(value) {
    try {
      const parsed = JSON.parse(value || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn("[ALLPOWERS 产品选型] 无法读取 Variant 选项。", error);
      return [];
    }
  }

  function getSectionId(root) {
    return root.dataset.sectionId || "";
  }

  function getSelectedCard(root, variantId) {
    return Array.from(root.querySelectorAll(CARD_SELECTOR)).find(
      (card) => String(card.dataset.variantId) === String(variantId)
    );
  }

  function updateSelectedCard(root, variantId) {
    root.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const selected =
        String(card.dataset.variantId) === String(variantId);

      card.classList.toggle("is-selected", selected);

      const radio = card.querySelector(INPUT_SELECTOR);
      if (radio) {
        radio.checked = selected;
      }

      const control = card.querySelector('[role="radio"]');
      if (control) {
        control.setAttribute("aria-checked", selected ? "true" : "false");
        if (card.classList.contains("has-details")) {
          control.setAttribute("aria-expanded", selected ? "true" : "false");
        }
      }
    });
  }

  function syncNativeVariant(root, visibleInput) {
    if (visibleInput.dataset.currentProduct !== "true") return;

    const options = parseOptions(visibleInput.dataset.variantOptions);
    if (!options.length) return;

    const nativeInputs = Array.from(
      root.querySelectorAll(NATIVE_INPUT_SELECTOR)
    );
    const changedInputs = [];

    options.forEach((value, index) => {
      const variantValue = `${value}-${index}`;
      const nativeInput = nativeInputs.find(
        (input) => input.dataset.variantValue === variantValue
      );

      if (!nativeInput) return;

      if (!nativeInput.checked) {
        nativeInput.checked = true;
        changedInputs.push(nativeInput);
      }
    });

    const eventTarget =
      changedInputs[changedInputs.length - 1] ||
      nativeInputs.find((input) => input.checked);

    if (eventTarget) {
      eventTarget.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function setInputValue(input, variantId) {
    if (!input) return;
    input.disabled = false;
    input.value = String(variantId);
    input.setAttribute("value", String(variantId));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function syncProductForms(root, variantId) {
    const sectionId = getSectionId(root);
    const productForm = document.getElementById(`productForm-${sectionId}`);
    const installmentForm = document.getElementById(
      `productFormInstallment-${sectionId}`
    );

    setInputValue(
      productForm ? productForm.querySelector('[name="id"]') : null,
      variantId
    );
    setInputValue(
      installmentForm ? installmentForm.querySelector('[name="id"]') : null,
      variantId
    );

    document
      .querySelectorAll(
        "sht-prd-frm-sticky .js-product-sticky-form-input-id, " +
          "sht-prd-frm-sticky [name='id']"
      )
      .forEach((input) => setInputValue(input, variantId));
  }

  function setLineItemProperty(form, propertyName, value) {
    if (!form) return;

    const inputName = `properties[${propertyName}]`;
    let input = Array.from(form.querySelectorAll('input[type="hidden"]')).find(
      (item) => item.name === inputName
    );

    if (!value) {
      if (input) input.remove();
      return;
    }

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = inputName;
      input.dataset.dePreorderProperty = "true";
      form.appendChild(input);
    }

    input.value = value;
  }

  function clearPreorderProperties(form) {
    if (!form) return;
    form
      .querySelectorAll('[data-de-preorder-property="true"]')
      .forEach((input) => input.remove());
  }

  function syncPreorderState(root, card) {
    if (!card) return;

    const sectionId = getSectionId(root);
    const productForm = document.getElementById(`productForm-${sectionId}`);
    const isPreorder = card.dataset.preorderEnabled === "true";
    const preorderItem = card.dataset.preorderItem || "";
    const preorderShipping = card.dataset.preorderShipping || "";
    const splitShipping = card.dataset.preorderSplitShipping === "true";

    clearPreorderProperties(productForm);

    if (isPreorder) {
      setLineItemProperty(productForm, "Vorbestellung", "Ja");
      setLineItemProperty(
        productForm,
        "Vorbestellter Artikel",
        preorderItem
      );
      setLineItemProperty(
        productForm,
        "Voraussichtlicher Versand",
        preorderShipping ? `Ab ${preorderShipping}` : "Termin auf Anfrage"
      );
      setLineItemProperty(
        productForm,
        "Teillieferung",
        splitShipping ? "Ja" : ""
      );
    }

    const dynamicCheckoutTargets = document.querySelectorAll(
      `#shopify-section-${sectionId} sht-load-dyn-co-btn, ` +
        `#shopify-section-${sectionId} .shopify-payment-button, ` +
        `sht-prd-frm-sticky sht-load-dyn-co-btn, ` +
        `sht-prd-frm-sticky .shopify-payment-button`
    );

    dynamicCheckoutTargets.forEach((target) => {
      target.hidden = isPreorder;
      target.classList.toggle("de-po__dynamic-checkout-hidden", isPreorder);
      target.setAttribute("aria-hidden", isPreorder ? "true" : "false");
    });

    const addButtons = [
      productForm
        ? productForm.querySelector(".js-product-form-submit-btn")
        : null,
      document.querySelector(
        "sht-prd-frm-sticky .js-product-form-submit-btn"
      )
    ].filter(Boolean);

    addButtons.forEach((button) => {
      if (!button.dataset.deOriginalButtonStyle) {
        button.dataset.deOriginalButtonStyle = button.classList.contains(
          "btn-secondary"
        )
          ? "secondary"
          : "primary";
      }

      if (isPreorder) {
        button.classList.remove("btn-secondary");
        button.classList.add("btn-primary");
      } else if (button.dataset.deOriginalButtonStyle === "secondary") {
        button.classList.remove("btn-primary");
        button.classList.add("btn-secondary");
      }
    });

    document.documentElement.classList.toggle("de-preorder-selected", isPreorder);
  }

  function replaceFromTemplate(target, template) {
    if (!target || !template) return;
    target.replaceChildren(template.content.cloneNode(true));
  }

  function syncProductInformation(root, card) {
    if (!card) return;

    const sectionId = getSectionId(root);
    const priceTarget = document.getElementById(`productPrice-${sectionId}`);
    const inventoryTarget = document.getElementById(
      `inventoryTracking-${sectionId}`
    );
    const priceTemplate = card.querySelector(
      "[data-de-option-price-template]"
    );
    const inventoryTemplate = card.querySelector(
      "[data-de-option-inventory-template]"
    );

    replaceFromTemplate(priceTarget, priceTemplate);
    replaceFromTemplate(inventoryTarget, inventoryTemplate);

    const stickyPrice = document.querySelector(
      "#productStickyInfo-product-sticky-bar .js-product-sticky-info-price"
    );
    if (stickyPrice && priceTarget) {
      stickyPrice.innerHTML = priceTarget.innerHTML;
    }

    const stickyVariant = document.querySelector(
      "#productStickyInfo-product-sticky-bar .js-product-sticky-info-variant"
    );
    if (stickyVariant) {
      stickyVariant.textContent = card.dataset.cardTitle || "";
    }

    const productForm = document.getElementById(`productForm-${sectionId}`);
    const addButton = productForm
      ? productForm.querySelector(".js-product-form-submit-btn")
      : null;
    if (addButton) {
      addButton.disabled = false;
      addButton.removeAttribute("aria-disabled");
      const addButtonText = addButton.querySelector(
        ".js-product-form-submit-btn-text"
      );
      if (addButtonText && root.dataset.addToCartLabel) {
        addButtonText.textContent = root.dataset.addToCartLabel;
      }
    }
  }

  function selectOption(root, visibleInput) {
    if (!visibleInput || visibleInput.disabled) return;

    const variantId = visibleInput.value;
    const card = getSelectedCard(root, variantId);

    updateSelectedCard(root, variantId);
    syncNativeVariant(root, visibleInput);
    syncProductForms(root, variantId);
    syncProductInformation(root, card);
    syncPreorderState(root, card);

    root.dispatchEvent(
      new CustomEvent("de:product-option:change", {
        bubbles: true,
        detail: {
          variantId: String(variantId),
          currentProduct: visibleInput.dataset.currentProduct === "true"
        }
      })
    );
  }

  function initializeRoot(root) {
    if (root.dataset.deProductOptionsReady === "true") return;
    root.dataset.deProductOptionsReady = "true";

    root.addEventListener("change", (event) => {
      const visibleInput = event.target.closest(INPUT_SELECTOR);
      if (!visibleInput || !root.contains(visibleInput)) return;
      selectOption(root, visibleInput);
    });

    let selectedInput = root.querySelector(`${INPUT_SELECTOR}:checked`);
    if (!selectedInput) {
      selectedInput = root.querySelector(INPUT_SELECTOR);
      if (selectedInput) selectedInput.checked = true;
    }

    if (selectedInput) {
      selectOption(root, selectedInput);
    }
  }

  function initializeAll(scope) {
    const context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll(ROOT_SELECTOR).forEach(initializeRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll(document));
  } else {
    initializeAll(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeAll(event.target);
  });
})();
